// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Oi5U","productName":"Table_productName__3YcaW"};